// frontend/src/components/Navigation.js

import React from 'react';
import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout, setViewMode } from '../authSlice';
import {
  PieChart as BrandIcon,
  Grid as DashboardIcon,
  Briefcase as PortfolioIcon,
  Repeat as TransactionsIcon,
  BarChart2 as AnalyticsIcon,
  Settings as AccountsIcon,
  User as UserIcon,
  LogOut as LogoutIcon,
  DollarSign as GainsIcon,
  Monitor as DesktopIcon,
  Smartphone as MobileIcon,
} from 'react-feather';
import ThemeToggleButton from './ThemeToggleButton';
import { useMediaQuery } from '../hooks/useMediaQuery';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { accessToken, viewMode } = useSelector((state) => state.auth); // Get viewMode

  // --- NEW: Logic for the view toggle button ---
  const isMobile = useMediaQuery('(max-width: 768px)');
  const showMobileView = (isMobile && viewMode !== 'desktop') || viewMode === 'mobile';

  const handleViewToggle = () => {
    if (showMobileView) {
      dispatch(setViewMode('desktop'));
    } else {
      dispatch(setViewMode('mobile'));
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  if (!accessToken) {
    return null;
  }

  const isActive = (path) => location.pathname === path;

  return (
    // --- FIX: Removed bg="white" and added our custom class ---
    <Navbar expand="lg" className="sticky-top shadow-sm theme-aware-navbar">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="fw-bold text-primary d-flex align-items-center">
          <BrandIcon size={24} className="me-2" />
          <span>Portfolio Tracker</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar-nav" />

        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" active={isActive('/')}>
              <DashboardIcon size={16} className="me-2" />
              Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to="/portfolio" active={isActive('/portfolio')}>
              <PortfolioIcon size={16} className="me-2" />
              Portfolio
            </Nav.Link>
            <Nav.Link as={Link} to="/gains" active={isActive('/gains')}>
              <GainsIcon size={16} className="me-2" />
              Gains
            </Nav.Link>
            <Nav.Link as={Link} to="/transactions" active={isActive('/transactions')}>
              <TransactionsIcon size={16} className="me-2" />
              Transactions
            </Nav.Link>
            <Nav.Link as={Link} to="/analytics" active={isActive('/analytics')}>
              <AnalyticsIcon size={16} className="me-2" />
              Analytics
            </Nav.Link>
            <Nav.Link as={Link} to="/accounts" active={isActive('/accounts')}>
              <AccountsIcon size={16} className="me-2" />
              Accounts
            </Nav.Link>
          </Nav>

          <Nav className="d-flex align-items-center flex-row">
            {isMobile && location.pathname === '/' && (
              <Button variant="outline-secondary" onClick={handleViewToggle} className="me-2" title={showMobileView ? 'Switch to Full View' : 'Switch to Mobile View'}>
                {showMobileView ? <DesktopIcon size={16} /> : <MobileIcon size={16} />}
              </Button>
            )}

            <div className="me-2">
              <ThemeToggleButton />
            </div>
            <NavDropdown
              title={
                <span className="d-flex align-items-center">
                  <UserIcon size={18} />
                </span>
              }
              id="account-dropdown"
              align="end"
            >
              <NavDropdown.Header>
                Signed in
              </NavDropdown.Header>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                <LogoutIcon size={16} className="me-2" />
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;